import React, { useState, useRef, useEffect } from 'react';
import './calendarYearStyle.css';
// import ExpandArrow from "./ExpandDownArrow.svg"
import { ReactComponent as ExpandArrow } from "../../../../../assets/orderClient/ExpandDownArrow.svg"

const CustomYearSelect = ({ selectedYear, onYearChange, startYear, endYear }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const selectedRef = useRef(null);

  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (open && selectedRef.current) {
      selectedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [open]);

  return (
    <div className="custom-year-dropdown" ref={dropdownRef}>
      <div
        className="custom-year-selected"
        onClick={() => setOpen((prev) => !prev)}
      >
        {selectedYear}
        <span className="arrow" style={{transform:open?"rotate(180deg)":"rotate(0deg)",transition:"all .3s ease"}} >
        <ExpandArrow />
        </span>
      </div>

      {open && (
        <div className="custom-year-options">
          {years.map((year) => (
            <div
              key={year}
              ref={year === selectedYear ? selectedRef : null}
              className={`custom-year-option ${year === selectedYear ? 'selected' : ''}`}
              onClick={() => {
                onYearChange(year);
                setOpen(false);
              }}
            >
              {year}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomYearSelect;
